<template>
  <!-- honeypot technique stops spam bots from submitting forms without the need for captcha -->
  <input
    type="text"
    :name="name"
    v-model="value"
    style="display:none !important"
    tabindex="-1"
    autocomplete="off"
  />
</template>
<script>
export default {
  data() {
    return {
      value: null,
      name: null,
      adjectives: [
        'jazzy',
        'brainy',
        'amusing',
        'aboard',
        'didactic',
        'thirsty',
        'cut',
        'placid',
        'wild',
        'standing',
        'direful',
        'nostalgic',
        'needy',
        'encouraging',
        'exotic',
        'plain',
        'stingy',
        'handsomely',
        'imminent',
        'fat',
        'bashful',
        'loud',
        'agreeable',
        'gusty',
        'untruthful',
        'strange',
        'accurate',
        'voiceless',
        'waggish',
        'sharp',
        'cool',
        'wide-eyed',
        'troubled',
        'female',
        'null',
        'used',
        'cooing',
        'private',
        'tawdry',
        'unusual',
        'clever',
        'recondite',
        'ill-fated',
        'tense',
        'perfect',
        'phobic',
        'slimy',
        'pale',
        'angry',
        'momentous',
      ],
      nouns: [
        'club',
        'vessel',
        'division',
        'dress',
        'swim',
        'direction',
        'hobbies',
        'rock',
        'achiever',
        'reward',
        'mass',
        'cart',
        'value',
        'lip',
        'pipe',
        'turn',
        'voice',
        'breath',
        'punishment',
        'fang',
        'north',
        'airplane',
        'ocean',
        'current',
        'plot',
        'sink',
        'sail',
        'trouble',
        'space',
        'hate',
        'person',
        'toothbrush',
        'fog',
        'yard',
        'letter',
        'money',
        'amount',
        'insect',
        'selection',
        'crime',
        'army',
        'zephyr',
        'clover',
        'table',
        'wealth',
        'plough',
        'power',
        'thought',
        'dust',
        'eye',
      ],
    };
  },
  computed: {
    robotCheck() {
      if (this.value) {
        return false;
      }
      return true;
    },
  },
  methods: {
    generateName() {
      let adjective = this.adjectives[
        Math.floor(Math.random() * this.adjectives.length)
      ];
      let noun = this.nouns[Math.floor(Math.random() * this.nouns.length)];
      let name = `${adjective}_${noun}`;
      return name;
    },
  },
  created() {
    this.name = this.generateName();
  },
};
</script>
